import {
    Control, FieldValues, useController,
    Path,
} from 'react-hook-form';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import { DateInputWithPicker } from '../date-input/date-picker';

export function DateInputWithPickerField<TFormValues extends FieldValues>({
    control,
    name,
    label,
    isRequired = false,
    allowClear = true,
    isDisabled = false,
}: {
    control: Control<TFormValues>;
    name: Path<TFormValues>;
    label?: string;
    isRequired?: boolean;
    allowClear?: boolean;
    isDisabled?: boolean;
}) {
    const {
        field,
        fieldState: { error, invalid },
    } = useController({
        name,
        control,
    });

    return (
        <FormControl isInvalid={invalid} isRequired={isRequired}>
            {
                label !== undefined
                    ? (
                        <FormLabel>{label}</FormLabel>
                    )
                    : null
            }
            <DateInputWithPicker
                {...field}
                allowClear={allowClear}
                placeholder="dd/mm/yyyy"
                noDateSelectedText="Select or enter date"
                isInvalid={invalid}
                size="md"
                disabled={isDisabled}
            />
            <FormErrorMessage>
                {error && error?.message}
            </FormErrorMessage>
        </FormControl>
    );
}
